import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * This component adds the effect of scrolling the screen to the top when
 * the URL is changed via routes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
